import type { VV } from '@semios/app-platform-value-type-definitions'
import { InsectValueTypePrefixes } from '@semios/app-platform-values-helpers-and-types'

const {
  INSECT_DEGREE_DAY_VALUE_KEY_PREFIX,
  INSECT_TRAP_CATCHES_VALUE_KEY_PREFIX,
  INSECT_TRAP_CATCHES_PERCENTAGE_VALUE_KEY_PREFIX,
} = InsectValueTypePrefixes

export const getTrapValueTypeIdForInsectId = (insectId: number) => {
  return `${INSECT_TRAP_CATCHES_VALUE_KEY_PREFIX}${insectId}` as VV.DomainTypes.TrapCatchesInsect.TTimeseriesValueTypeKeysMerged
}

export const getTrapPercentageValueTypeIdForInsectId = (insectId: number) => {
  return `${INSECT_TRAP_CATCHES_PERCENTAGE_VALUE_KEY_PREFIX}${insectId}` as keyof VV.DomainTypes.TrapCatchesInsect.TValuesReturnWithMetaIgnoringKeying['regions']
}

export const getDegreeDayValueTypeIdForInsectId = (insectId: number) => {
  return `${INSECT_DEGREE_DAY_VALUE_KEY_PREFIX}${insectId}` as VV.DomainTypes.DegreeDaysInsect.TTimeseriesValueTypeKeysMerged
}
